import { Button, ButtonLevel, ButtonSize } from '@vizit/atoms';
import { PlusIcon } from '@vizit/icons';

export interface UploadImagesButtonProps {
  /**
   * Called when the button is pressed, e.g. to open the upload dialog
   *
   * @optional
   */
  onPress?: () => void;
  /**
   * Whether the button is disabled
   *
   * @optional
   * @default false
   */
  isDisabled?: boolean;
}

/**
 * A benchmark page's "Upload images" button, sized as in the design: a 20px plus, then the label in semibold.
 */
export function UploadImagesButton({ onPress, isDisabled = false }: UploadImagesButtonProps) {
  return (
    <Button
      level={ButtonLevel.Primary}
      size={ButtonSize.Lg}
      iconStart={<PlusIcon size={20} aria-hidden />}
      onPress={onPress}
      isDisabled={isDisabled}
      className="gap-2 font-semibold text-md [&>svg]:h-10 [&>svg]:w-10 [&>svg]:text-quaternary-on-brand"
    >
      <span className="px-1">Upload images</span>
    </Button>
  );
}
